/**
 * Represents the location details of a booking.
 */
export class TimeEntryBookingLocationDTO {
  /**
   * @param {Object} locationData - The location data object.
   * @param {number} locationData.id - Unique identifier for the location.
   * @param {string} locationData.name - Name of the location.
   * @param {string} locationData.timeZone - Location's timezone
   */
  constructor(locationData) {
    /**
     * Unique identifier for the location.
     * @type {number}
     */
    this.id = locationData.id

    /**
     * Name of the location.
     * @type {string}
     */
    this.name = locationData.name

    /**
     * The location's timezone
     * @type {string}
     * @example Australia/Melbourne
     */
    this.timeZone = locationData.timeZone
  }
}
